import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseTime } from '@/utils';
import { getDateEnd, getDateStampEndOfMonth, getDateStart, getLimitAgo } from '@/utils/date';
import { configEnum } from '@/enum';
export default {
  name: 'DateRange',
  filters: {
    getTime: function getTime(val) {
      return parseTime(val, '{y}/{m}/{d}');
    }
  },
  props: {
    value: {
      type: [Array, null],
      default: null,
      require: true
    },
    maxUseEndTime: {
      type: Boolean,
      default: true
    },
    limitRange: {
      // 0:no limit
      type: Number,
      require: false,
      default: configEnum.rangeLimitDay * 24 * 3600 * 1000
    },
    type: {
      type: String,
      require: false,
      default: 'daterange'
    },
    clearable: {
      type: Boolean,
      require: false,
      default: true
    },
    defaultRange: {
      type: Boolean,
      require: false,
      default: false
    },
    startPlaceholder: {
      type: String,
      require: false,
      default: function _default() {
        return this.$t('common.startTime');
      }
    },
    endPlaceholder: {
      type: String,
      require: false,
      default: function _default() {
        return this.$t('common.endTime');
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      date: null,
      firstDate: 0,
      pickerOptions: {
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          if (!maxDate) {
            _this.firstDate = minDate;
          }
        },
        disabledDate: function disabledDate(val) {
          if (_this.limitRange && _this.firstDate) {
            return Math.abs(val.getTime() - _this.firstDate) >= _this.limitRange;
          }
          return false;
        }
      },
      mobileStartDate: '',
      mobileEndDate: ''
    };
  },
  created: function created() {
    var _this2 = this;
    if (this.value) {
      this.date = this.value;
    }
    if (this.defaultRange) {
      this.handleChange([getDateStart(getLimitAgo()).getTime(), getDateEnd(new Date()).getTime()]);
    }
    this.$nextTick(function () {
      _this2.value2MobileBinds();
    });
  },
  methods: {
    handleChange: function handleChange(val) {
      if (val) {
        if (this.type === 'monthrange') {
          val[1] = getDateStampEndOfMonth(new Date(val[1]));
        } else {
          val[1] = getDateEnd(new Date(val[1])).getTime();
        }
      }
      this.firstDate = 0;
      this.$emit('input', val);
      this.$emit('change', val);
      this.date = val;
    },
    handleMobileLeftChange: function handleMobileLeftChange(e) {
      if (!e.target.value) {
        this.handleChange(null);
        return;
      }
      var val = e.target.value.split('-');
      var timestamp = new Date(val[0], val[1] - 1, val[2]).getTime();
      var result = [timestamp, this.value ? this.value[1] : Date.now()];
      this.handleChange(result);
    },
    handleMobileRightChange: function handleMobileRightChange(e) {
      if (!e.target.value) {
        this.handleChange(null);
        return;
      }
      var val = e.target.value.split('-');
      var timestamp = getDateEnd(new Date(val[0], val[1] - 1, val[2])).getTime();
      var result = [this.value ? this.value[0] : timestamp, timestamp];
      this.handleChange(result);
    },
    value2MobileBinds: function value2MobileBinds() {
      if (!this.value) {
        return;
      }
      this.mobileStartDate = parseTime(this.value[0], '{y}-{m}-{d}');
      this.mobileEndDate = parseTime(this.value[1], '{y}-{m}-{d}');
    }
  }
};